module.exports = __webpack_public_path__ + "static/media/DPDC_LOGO.8f80358b.png";